import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/languages.vue
var s = {
	name: "DtIconLanguages",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--languages"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Languages",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor"
	}, [...t[0] || (t[0] = [
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M3 1a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 3 1Z"
		}, null, -1),
		i("path", { d: "M2.146 3.646a.5.5 0 0 1 .708 0l.896.897.861-.862L5.066 3H1a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1h-.732l-.852 1.277a.5.5 0 0 1-.062.077l-.897.896 1.397 1.396a.5.5 0 1 1-.708.708L3.75 5.957 2.354 7.354a.5.5 0 1 1-.708-.708L3.043 5.25l-.897-.896a.5.5 0 0 1 0-.708Z" }, null, -1),
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M8.5 5.5a.5.5 0 0 1 .447.276l2.5 5a.5.5 0 1 1-.894.448L9.69 9.5H7.309l-.862 1.724a.5.5 0 1 1-.894-.448l2.5-5A.5.5 0 0 1 8.5 5.5Zm-.691 3L8.5 7.118 9.191 8.5H7.809Z"
		}, null, -1)
	])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=languages.js.map